import type { FC } from 'react'
import { useEffect, useRef, useState } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Button, TextField, Typography } from '@mui/material'

interface InitialMessageStepProps {
  readonly initialValue: string
  readonly onNext: (initialMessage: string) => void
  readonly onBack: () => void
}

export const InitialMessageStep: FC<InitialMessageStepProps> = ({
  initialValue,
  onNext,
  onBack,
}) => {
  const [message, setMessage] = useState(initialValue)
  const messageRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    messageRef.current?.focus()
  }, [])

  return (
    <Box sx={containerSx}>
      <Typography variant="h6" sx={titleSx}>
        Initial Message
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={descriptionSx}>
        Optionally provide an initial message for Claude to work on when the session starts.
      </Typography>

      <TextField
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="What should Claude work on?"
        fullWidth
        multiline
        rows={5}
        inputRef={messageRef}
        sx={fieldSx}
      />

      <Box sx={actionsSx}>
        <Button onClick={onBack}>Back</Button>
        <Button variant="contained" onClick={() => onNext(message)}>
          Next
        </Button>
      </Box>
    </Box>
  )
}

const containerSx: SxProps<Theme> = {
  py: 2,
}

const titleSx: SxProps<Theme> = {
  fontWeight: 600,
  mb: 1,
}

const descriptionSx: SxProps<Theme> = {
  mb: 3,
}

const fieldSx: SxProps<Theme> = {
  mb: 3,
}

const actionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  mt: 4,
}
